import React from 'react';
import {
  TextField as MUITextField,
  TextFieldProps as MUITextFieldProps
} from '@mui/material';
import { useEffect, useRef } from 'react';
import { classNameBuilder } from '../../utilities';

class ExtendedTextFieldProps {
  readOnly?: boolean;
  startAdornment?: React.ReactNode;
  endAdornment?: React.ReactNode;
  focus?: boolean;
  minValue?: number;
}

type TextFieldProps = MUITextFieldProps & ExtendedTextFieldProps;

export default function TextField({
  label,
  value,
  className,
  id,
  onChange,
  onKeyDown,
  error,
  disabled,
  autoComplete,
  readOnly,
  startAdornment,
  endAdornment,
  type,
  placeholder,
  focus,
  minValue = 0,
  ...props
}: TextFieldProps) {
  const fieldRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (focus) {
      const currentFieldRef = fieldRef.current;
      const firstChild = currentFieldRef?.children[0]?.children[0];
      const secondChild = currentFieldRef?.children[0]?.children[1];
      const toFocus =
        firstChild?.toString() === '[object HTMLInputElement]'
          ? firstChild
          : secondChild;

      (toFocus as HTMLInputElement)?.focus();
    }
  }, [focus]);

  return (
    <MUITextField
      {...props}
      ref={fieldRef}
      id={id}
      type={type}
      key={props.key}
      label={label}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      onKeyDown={onKeyDown}
      className={classNameBuilder(
        'h-app-input-field',
        readOnly ? 'readonly' : '',
        className ?? ''
      )}
      size='small'
      error={error}
      disabled={disabled}
      autoComplete={autoComplete}
      InputProps={{
        inputProps: { min: minValue },
        readOnly: readOnly,
        startAdornment: startAdornment,
        endAdornment: endAdornment
      }}
    />
  );
}
